
document.addEventListener("DOMContentLoaded", function () {
  // Run only on mobile (screen width ≤ 749px)
  if (window.innerWidth > 749) return;

  const stickyHeader = document.querySelector(".mega-sticky-header");

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function() {
    if (
      document.body.classList.contains("search-opened") ||
      stickyHeader.classList.contains("search-force-visible")
    ) {
      stickyHeader.classList.remove("hide");
      prevScrollpos = window.pageYOffset;
      return;
    }

    var currentScrollPos = window.pageYOffset;
    if (currentScrollPos <= 50) {
      stickyHeader.classList.remove("hide");
    }
    else if (prevScrollpos > currentScrollPos) {
      stickyHeader.classList.remove("hide");
    } else {
      stickyHeader.classList.add("hide");
    }
    prevScrollpos = currentScrollPos;
  }

});
